import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ServiceBalancesFilter from "./ServiceBalancesFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import ServiceBalancesList from "./ServiceBalancesList";
import Notification from "../../elements/notification/Notification";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import PageSpinner from "../../elements/spinner/PageSpinner";

import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";

import DefaultButton from "../../styles/materialButtonStyle";
import MaterialPagination from "../../styles/materialPagination";
import {
  StyledServiceBalancesUpdate,
  StyledServiceBalancesUpdateLoading,
  StyledServiceBalancesWrapper
} from "../styledServiceBalances";

import {itemsPerPageValue} from "../../../utils/ItemsPerPageValue";

const ServiceBalancesContainer = () => {
  const history = useHistory();
  const { t } = useTranslation("serviceBalancesPage");

  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [serviceBalances, setServiceBalances] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", "service-balances"),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "serviceName": checkFilterItem(history, "serviceName", null),
    "client": checkFilterItem(history, "client", null),
    "currency": checkFilterItem(history, "currency", null)
  });
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const updateServiceBalances = () => {
    setLoading(true);

    axios.post("/api/service-balances/update", {}, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("updatedSuccess")
        });
        setRefetch(!refetch);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  const fetchServiceBalances = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/service-balances" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setServiceBalances(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchServiceBalances();
  }, [filterData, refetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledServiceBalancesWrapper>
          {loading &&
            <StyledServiceBalancesUpdateLoading>
              <PageSpinner />
            </StyledServiceBalancesUpdateLoading>}
          <div className="service-balances-head">
            <ServiceBalancesFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <StyledServiceBalancesUpdate className="service-balances-head__update">
              <DefaultButton
                onClick={updateServiceBalances}
                color="success"
              >
                {t("updateBalance")}
              </DefaultButton>
            </StyledServiceBalancesUpdate>
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ServiceBalancesList
            serviceBalances={serviceBalances}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledServiceBalancesWrapper>
    </>
  );
};

export default ServiceBalancesContainer;